import * as React from 'react';
import styles from './ConnectionBanner.module.scss'
import { connect } from 'react-redux';
import { IStore } from '../../../redux/initialState';
import { useEffect, useState } from 'react';
import OfflineBanner from '../OfflineBanner/OfflineBanner';
import cn from 'classnames';

function ConnectionBanner({ connectionDetails }) {
    const [online, setOnline] = useState(navigator.onLine);

    useEffect(() => {
        const updateOnlineStatus = () => {
            setOnline(navigator.onLine);
        };
        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    }, []);

    return (
        online ?
            <>
                {
                    (connectionDetails?.status === 'error' || connectionDetails?.status === 'disconnected') ?
                        <div className={styles.root}>
                            <i className={cn('icon icon-alan-info-sign', styles.icon)} />
                            Could not connect to the server, trying to reconnect...
                        </div> : <></>
                }
            </> :
            <OfflineBanner />
    );
}

function mapStateToProps({ projectsInfo }: IStore) {
    return {
        connectionDetails: projectsInfo.connectionDetails,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionBanner);
